exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BrandResultInfoItem {\n  border-bottom: 10px solid #1825D8;\n}\n.BrandResultInfoItem h4 {\n  font-size: 30px;\n  font-weight: 900;\n  letter-spacing: 9px;\n  color: #1D2CF3;\n}\n@media (max-width: 767px) {\n.BrandResultInfoItem h4 {\n    font-size: 16px;\n    letter-spacing: 4px;\n}\n}\n", ""]);

// exports
